import { DateTime } from "luxon";

export const getTodaysDate = () => {
  return DateTime.now().toLocaleString(DateTime.DATETIME_HUGE_WITH_SECONDS);
};
